export function isStringEmpty(s: string | undefined | null): boolean {
  return (s ?? "").trim().length === 0
}

export function isStringNotEmpty(s: string | undefined | null): s is string {
  return !isStringEmpty(s)
}

// A simple, *insecure* 32-bit hash that's short, fast, and has no dependencies.
// Output is always 7 characters.
// Loosely based on the Java version; see
// https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
export function simpleHash(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)

    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + char
  }
  // Convert to 32bit unsigned integer in base 36
  // and pad with "0" to ensure length is 7.

  // eslint-disable-next-line no-bitwise
  return (hash >>> 0).toString(36).padStart(7, "0")
}

export function formatMoney(dollars: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    maximumSignificantDigits: 2,
  }).format(dollars)
}
